import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import {
  loadAisConfigurationForDeviceFailure,
  loadAisConfigurationForDeviceRequest,
  loadAisConfigurationForDeviceSuccess,
} from './analog-inputs.actions';

import { ConnectionService } from '@app/services/connection.service';

@Injectable()
export class AnalogInputsEffects {
  private actions$ = inject(Actions);
  private cn = inject(ConnectionService);
  private toastr = inject(ToastrService);

  handleLoadAnalogInputsRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadAisConfigurationForDeviceRequest),
      mergeMap((action) =>
        this.cn.client.request.getSupportedAis(action.deviceRef).pipe(
          map((supportedAis: number[][]) =>
            loadAisConfigurationForDeviceSuccess({ deviceRef: action.deviceRef, supportedAis }),
          ),
          catchError((error) => of(loadAisConfigurationForDeviceFailure({ error }))),
        ),
      ),
    ),
  );

  handleLoadErrorReportsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadAisConfigurationForDeviceFailure),
        tap((action) => {
          this.toastr.error(
            'Failed to load analog input configurations. Error: ' + action.error?.message,
            'Load Analog Inputs Configuration',
            {
              disableTimeOut: true,
            },
          );
        }),
      ),
    { dispatch: false },
  );
}
